import { type JSX } from 'react';

import { Input } from '@/ui';

interface NumberFieldProps {
  id: string;
  label: string | JSX.Element;
  value: number | string | undefined;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  description?: string;
}

const NumberField = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  disabled,
  placeholder,
  description
}: NumberFieldProps) => (
  <div className="flex flex-col gap-1">
    <Input
      id={id}
      type="number"
      label={label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      helpText={description}
      error={error}
      aria-required={required || undefined}
    />
  </div>
);

export default NumberField;
